import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone } from "lucide-react";
import { SERVICES, COMPANY } from "../mock";

const companyLinks = [
  { label: "About", to: "/about" },
  { label: "Why Choose Us", to: "/about" },
  { label: "Industries We Serve", to: "/industries" },
  { label: "Our Process", to: "/process" },
  { label: "Testimonials", to: "/testimonials" },
  { label: "Contact", to: "/contact" },
];

export default function Footer() {
  return (
    <footer className="bg-[#0b2545] text-slate-300">
      <div className="max-w-[1240px] mx-auto px-5 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <img src="/armstrong-logo-white.png" alt="Armstrong Technologies" className="h-11 w-auto object-contain" />
            <p className="mt-6 text-[15px] text-slate-400">{COMPANY.tagline}</p>
            <div className="mt-8 space-y-3 text-[14px] text-slate-400">
              <div className="flex items-center gap-2">
                <MapPin className="w-4 h-4 text-[#14b8a6]" />
                <span>{COMPANY.location}</span>
              </div>
              <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-[#14b8a6] transition-colors">
                <Mail className="w-4 h-4 text-[#14b8a6]" />
                <span>{COMPANY.email}</span>
              </a>
              <a href={`tel:${COMPANY.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-[#14b8a6] transition-colors">
                <Phone className="w-4 h-4 text-[#14b8a6]" />
                <span>{COMPANY.phone}</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[11px] font-semibold tracking-[0.2em] text-slate-500 uppercase mb-5">Services</h4>
            <ul className="space-y-3">
              {SERVICES.map((s) => (
                <li key={s.slug}>
                  <Link to={`/services/${s.slug}`} className="text-[14px] text-slate-300 hover:text-[#14b8a6] transition-colors">
                    {s.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] font-semibold tracking-[0.2em] text-slate-500 uppercase mb-5">Company</h4>
            <ul className="space-y-3">
              {companyLinks.map((c, i) => (
                <li key={i}>
                  <Link to={c.to} className="text-[14px] text-slate-300 hover:text-[#14b8a6] transition-colors">
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] font-semibold tracking-[0.2em] text-slate-500 uppercase mb-5">Business Hours</h4>
            <ul className="space-y-3">
              {COMPANY.hours.map((h, i) => (
                <li key={i} className="flex items-center justify-between gap-4 text-[14px] text-slate-300">
                  <span>{h.day}</span>
                  <span className="text-slate-500">{h.time}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-[13px] text-slate-500">© 2026 {COMPANY.name}. All rights reserved.</p>
          <p className="text-[13px] text-slate-500">{COMPANY.tagline}</p>
        </div>
      </div>
    </footer>
  );
}
